import { render, staticRenderFns } from "./SettingRow.vue?vue&type=template&id=4673ecaa&scoped=true"
import script from "./SettingRow.vue?vue&type=script&lang=js"
export * from "./SettingRow.vue?vue&type=script&lang=js"
import style0 from "./SettingRow.vue?vue&type=style&index=0&id=4673ecaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673ecaa",
  null
  
)

export default component.exports